<template>
  <div>
    <div class="joinCompleteContain">
      <div class="completeTxt">
        <h2>회원가입이 완료 되었습니다.</h2>
      </div>
      <div class="completeBox">
        <p><span class="title">아이디</span> {{ getCompletedInfo.id }}</p>
        <p><span class="title">이름</span> {{ getCompletedInfo.name }}</p>
        <p>
          <span class="title">휴대폰 번호</span>
          {{ getCompletedInfo.phoneNumber }}
        </p>
      </div>

      <div class="btnBox flex topPd">
        <router-link to="/" class="btnFont goMainBtn completeBtnWD">메인으로 이동</router-link>
        <router-link to="/auth" class="btnFont goLoginBtn completeBtnWD">로그인</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('join', ['getCompletedInfo']),
  },
}
</script>

<style scoped>
.btnBox a.completeBtnWD {
  width: 200px;
  border-radius: 90px;
}
.btnBox a.goMainBtn {
  border: 1px solid #26336a;
  color: #26336a;
}
.btnBox a.goLoginBtn {
  background: #26336a;
  color: #fff;
  margin-left: 20px;
}
</style>
